import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { register, setToken, setUser } from '../services/auth';

const Register = ({ onRegister }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    if (values.password !== values.confirm) {
      message.error('两次输入的密码不一致');
      return;
    }
    setLoading(true);
    try {
      const data = await register(values.username, values.password);
      setToken(data.token);
      setUser(data.user);
      onRegister(data.user);
      message.success('注册成功');
      navigate('/');
    } catch (err) {
      message.error(err.response?.data?.error || '注册失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: '#f5f5f7',
      padding: 16,
    }}>
      <div style={{
        width: '100%',
        maxWidth: 400,
        background: 'rgba(255,255,255,0.72)',
        backdropFilter: 'blur(20px) saturate(180%)',
        WebkitBackdropFilter: 'blur(20px) saturate(180%)',
        borderRadius: 20,
        padding: '40px 32px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      }}>
        <div style={{
          fontSize: 28,
          fontWeight: 700,
          color: '#1d1d1f',
          textAlign: 'center',
          marginBottom: 8,
          letterSpacing: -0.5,
        }}>
          创建账号
        </div>
        <div style={{
          fontSize: 15,
          color: '#86868b',
          textAlign: 'center',
          marginBottom: 32,
          fontWeight: 400,
        }}>
          注册以开始使用快速记录
        </div>
        <Form name="register" onFinish={onFinish} autoComplete="off" layout="vertical">
          <Form.Item name="username" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input prefix={<UserOutlined style={{ color: '#86868b' }} />} placeholder="用户名" style={{ height: 48 }} />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined style={{ color: '#86868b' }} />} placeholder="密码" style={{ height: 48 }} />
          </Form.Item>
          <Form.Item name="confirm" rules={[{ required: true, message: '请确认密码' }]}>
            <Input.Password prefix={<LockOutlined style={{ color: '#86868b' }} />} placeholder="确认密码" style={{ height: 48 }} />
          </Form.Item>
          <Form.Item style={{ marginBottom: 16 }}>
            <Button type="primary" htmlType="submit" loading={loading} block style={{
              height: 48,
              fontSize: 16,
              fontWeight: 600,
              borderRadius: 12,
            }}>
              注册
            </Button>
          </Form.Item>
          <div style={{ textAlign: 'center', color: '#86868b', fontSize: 14 }}>
            已有账号？<Link to="/login" style={{ color: '#007AFF', fontWeight: 500 }}>立即登录</Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Register;
